export function generateTrackingNumber() {
    const randomNumber = Math.floor(10000000 + Math.random() * 90000000); // Generate a random number between 10000000 and 99999999
    return String(randomNumber).substring(0, 8); // Convert the number to a string and take the first 8 digits
}